module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey overline darken-4 py-1 white--text"
  }, [_vm._v("\n    Change appointment type/practitioner\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.req
    },
    on: {
      "ok": _vm.transferSuccess
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('center', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("\n    Where would you like to move this appointment?\n  ")]), _vm._v(" "), _c('practitioner-product-picker', {
    attrs: {
      "practitioner": _vm.topractitioner,
      "product": _vm.toproduct,
      "location": _vm.tolocation
    },
    on: {
      "update:practitioner": function($event) {
        _vm.topractitioner = $event
      },
      "update:product": function($event) {
        _vm.toproduct = $event
      },
      "update:location": function($event) {
        _vm.tolocation = $event
      }
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-4 py-2"
  }, [(_vm.product) ? [_c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("Change appointment type:")]), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("from:")]), _vm._v(" " + _vm._s(_vm.product.title) + " with " + _vm._s(_vm.appointment.practitioner_name)), _c('br')] : _vm._e(), _vm._v(" "), (_vm.toproduct && _vm.topractitioner) ? _c('div', {
    staticClass: "subheading"
  }, [_c('strong', {
    staticClass: "overline ml-2"
  }, [_vm._v("to:")]), _vm._v(" " + _vm._s(_vm.toproduct.title) + " with " + _vm._s(_vm.topractitioner.full_name) + " @ " + _vm._s(_vm.tolocation.name) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.locationId,
      "loading": _vm.req.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d500254","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/TransferAppointment/Index.vue
// module id = 1398
// module chunks = 9